import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { ShowNotificationByID } from "../services/notificationService.js"
import "../styles/notificationDetail.css"
import { useNavigate } from "react-router-dom"
import { linkificar } from "../scripts/linkificar.js"


export default function NotificationDetail() {
    const { id, sendemail } = useParams()
    const [notification, setNotification] = useState(null)
    const navigate = useNavigate()

    useEffect(() => {
        const checkNoti = async () => {
            const data = await ShowNotificationByID(id, sendemail)
            setNotification(data)
        }
        checkNoti()
    }, [id])

    if (!notification) return <div>Cargando...</div>

    const attachments = notification.notification.attachments || []

    return (
        <div className="card">
            <button className="btn-back" onClick={() => navigate(-1)}>Volver</button>
            <div className="card-header">
                <div className="notif-title">{notification.notification.title}</div>
            </div>
            <div className="sender-section">
                <div className="avatar">A</div>
                <div>
                    <div className="sender-name">{notification.transmitter.name_user} para {notification.receiver.name_user}</div>
                    <div className="sender-label">Remitente</div>
                </div>
                <div className="date">{new Date(notification.notification.created_at).toLocaleString('es-ES')}</div>
            </div>
            <div className="message-section">
                {linkificar(notification.notification.body)}
            </div>
        </div>
    )
}